export default __webpack_public_path__ + "static/sub-logo-en-c7a53342b4c115192d0a7d8e085aa027.png";